@import "~@govbr-ds/core/src/components/button/button";
@import "~@govbr-ds/core/src/components/magicbutton/magicbutton";

:host {
  display: block;
}
